"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const compliance_pool_types_1 = require("../compliance-pool-types");
const apiUtils_1 = require("../../../util/apiUtils");
const useMetadata_1 = require("../../../hooks/useMetadata");
const ComplianceKPI_1 = __importDefault(require("../common/ComplianceKPI"));
const compliance_1 = require("../../../util/compliance/compliance");
const LineChart_1 = __importDefault(require("../LineChart"));
const theme_1 = require("../../../theme");
const util_1 = require("../util");
const ShipTable_1 = require("../common/tables/ShipTable");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const YearContext_1 = require("../../../contexts/YearContext");
const react_1 = require("react");
exports.default = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const { poolId } = (0, react_router_dom_1.useParams)();
    const [pool, _setUrl, _setBody, _refresh] = (0, useFetch_1.default)("pool/pool.json", undefined, true);
    const [usageAnalysis, _setUsageAnalysisUrl, _setUsageAnalysisPostBody] = (0, useFetch_1.default)("pool/pool_fuel_usage.json", undefined, true);
    const [transactions, _setTransUrl, _setTransPostBody, refreshTransactions] = (0, useFetch_1.default)("transaction/transactions.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setBody(JSON.stringify({
            pool_id: Number(poolId),
            year: selectedYear,
        }));
        _setUsageAnalysisPostBody(JSON.stringify({ pool_id: Number(poolId), year: selectedYear }));
        _setTransPostBody(JSON.stringify({
            pool_id: Number(poolId),
            year: selectedYear,
        }));
    }, [selectedYear, poolId]);
    const [user] = (0, useFetch_1.default)("user/data.json");
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const poolData = pool.status === apiUtils_1.LoaderStatus.Success ? pool.data : null;
    const usageData = usageAnalysis.status === apiUtils_1.LoaderStatus.Success
        ? usageAnalysis.data
        : undefined;
    const analysis = usageData?.pool.analysis;
    const transactionData = transactions.status === apiUtils_1.LoaderStatus.Success ? transactions.data : null;
    const poiData = transactionData?.map((t) => (0, util_1.getTransactionPOI)(t, "neutral"));
    const forecastsAvailable = (0, compliance_pool_types_1.isForecast)(usageData?.pool.forecast) &&
        usageData?.pool.forecast.total !== undefined;
    // const forecastFuels = forecastsAvailable
    //   ? combineFuels(usageData.pool.forecast.forecast_fuels_total)
    //   : undefined;
    const forecastDate = forecastsAvailable
        ? new Date(usageData.pool.forecast.end)
        : undefined;
    // log([
    //   {
    //     label: "Metadata",
    //     content: metadata,
    //   },
    //   {
    //     label: "Pool data",
    //     content: pool ?? "loading",
    //   },
    //   {
    //     label: "Usage analysis",
    //     content: usageData ?? "loading",
    //   },
    // ]);
    const carbonLimitYear = selectedYear;
    if (poolData &&
        analysis &&
        metadata &&
        user.status === apiUtils_1.LoaderStatus.Success) {
        return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: poolData.name }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Ships: " }), poolData.ships.length] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(analysis.intensities.total.adjusted_emission_balance_ton), title: "Carbon intensity", unit: "gCO\u2082e/MJ", value: analysis.intensities.total.adjusted_intensity_gCO2e_per_MJ }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(analysis.intensities.total.adjusted_emission_balance_ton), title: "Carbon unit balance", unit: analysis.intensities.total.adjusted_emission_balance_ton < 0
                                    ? "tCO₂e deficit"
                                    : "tCO₂e to spare", value: (0, util_1.scaleEmissions)(analysis.intensities.total.adjusted_emission_balance_ton) }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 2, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Pool carbon intensity", unit: "gCO\u2082e/MJ", poiData: poiData, data: [
                                    {
                                        name: "Intensity",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.adjusted_intensity_gCO2e_per_MJ,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.pool.forecast.total
                                                    .adjusted_intensity_gCO2e_per_MJ,
                                            }
                                            : undefined,
                                    },
                                ], limits: [
                                    {
                                        label: `${carbonLimitYear} limit`,
                                        value: metadata.intensity[carbonLimitYear],
                                        color: theme_1.theme.colors.red,
                                    },
                                ] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Carbon unit balance", unit: "-tCO\u2082e", poiData: poiData, data: [
                                    {
                                        name: "Carbon unit balance",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.emission_balance_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.pool.forecast.total
                                                    .adjusted_emission_balance_ton,
                                            }
                                            : undefined,
                                    },
                                ] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative emissions", unit: "tCO\u2082e", poiData: poiData, data: [
                                    {
                                        name: "Emissions",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.co2_emission_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.pool.forecast.total
                                                    .adjusted_co2_emission_ton,
                                            }
                                            : undefined,
                                    },
                                    {
                                        name: "Emission limit",
                                        color: theme_1.theme.colors.red,
                                        dashed: true,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.emission_limit_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.pool.forecast.total.emission_limit_ton,
                                            }
                                            : undefined,
                                    },
                                ] }) })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Ships" }), (0, jsx_runtime_1.jsx)(ShipTable_1.ShipTable, { ships: poolData.ships, metadata: metadata, year: carbonLimitYear, isInAdminTools: false, userCompanyId: user.data.company.id, showCompany: true })] }) }), transactionData && transactionData.length > 0 && ((0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Compliance transactions" }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactionData, complianceYear: carbonLimitYear, poolId: poolData.id, refresh: refreshTransactions, isInAdminTools: false })] }) }))] }));
    }
    return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading pool\u2026" });
};
